var _circle, _rect, _ellipse, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaneDropIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 243,
    viewBox: "0 0 244 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.496,
    cy: 121.499,
    r: 121.5,
    fill: "#FFE5DA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105.996,
    y: 189,
    width: 38,
    height: 9,
    fill: "#FFE5DA"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.996,
    cy: 189.5,
    rx: 47,
    ry: 2.5,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.642 71.6191L108.517 53.8607L108.883 81.7655L126.951 75.4373L122.736 155.856L122.736 173L124.426 189.569L129.322 164.201L131.548 133.083L136.642 71.6191Z",
    fill: "#EF956F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.952 75.4376L86.8641 89.4629L106.713 143.572L110.505 150.53L111.317 159.836L116.998 168.001L120.997 178L123.997 189.002L124.496 189.5L123.497 179.501L123.997 177.501L124.933 165.928L123.446 157.514L125.549 146.208L126.952 75.4376Z",
    fill: "#FBBBA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.495 64.2286L136.575 71.7475L129.171 145.864L127.16 156.678L127.881 166.475L125.413 179.748L124.418 189.564L127.754 176.623L132.797 167.389L132.785 159.25L137.836 148.492L146.457 129.397L168.495 64.2286Z",
    fill: "#FBBBA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.95 75.4372L108.517 53.8606L108.882 81.7654L126.95 75.4372Z",
    fill: "#E85319"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneDropIcon);
export default __webpack_public_path__ + "static/media/plane-drop-icon.56f5f2c6.svg";
export { ForwardRef as ReactComponent };